// TODO: This file is somewhat of a catchall - once we have enough here to sensibly break it up, we should
// TODO: figure out some sort of capitalization consistency
import { SUPPORTED_CROPS } from 'constants/crops';

export const timeouts = {
  INITIAL_PAGE_LOAD_WARNING: 60000, // TODO: gain confidence, then lower this value (30sec?)
  YIELD_THUMBNAIL_LOAD: 5000,
  HIDE_GOOGLE_MAP_ICONS: 1000,
  CONSOLIDATE_EDITS_WAIT_TIME: 200, // yes, 200.  How long to wait to see there are no further edits before drawing, to save CPU
  HIDE_TOAST_MESSAGE: 4000,
  SERVICE_CALL: 30000,
  MANUAL_PRESCRIPTION_ZONES: 60000 // We can request more than 1000 zones, 30 sec is not always enough
};

export const inputStates = {
  CHANGED: 'CHANGED',
  PENDING: 'PENDING',
  INSYNC: 'INSYNC'
};

export const messageTypes = {
  SUCCESS: 'SUCCESS', // Something went good
  NEUTRAL: 'NEUTRAL', // Meh
  ERROR: 'ERROR', // Something went wrong
  SYSTEM_ERROR: 'SYSTEM_ERROR',
  MODAL: 'MODAL', // modal messaging
  CHOICE: 'CHOICE' // A message where user makes a choice between 2 or more options.
};

// Message IDs for cases where explicitly assigning one is useful. See addMessage() comments for explanation.
export const messageIds = {
  'BULK_DOWNLOAD_FILES': -1,
  'DOWNLOAD_FILE': -2,
  'DRAWING_INSTRUCTION': -3,
  'CONNECT_TO_AFFILIATE': -4,
  'SEND_TO_AFFILIATE': -5,
  'SAVING_PRESCRIPTION': -6
}; // Uses negative value IDs that won't conflict with automatically-generated IDs.

export const MAX_ALLOWED_HYBRIDS = 2;
export const DEFAULT_CROP = 'corn';
export const DEFAULT_CROP_DFP_UUID = SUPPORTED_CROPS.find(({ code }) => code === DEFAULT_CROP)['dfp-uuid'];

export const exportTypes = {
  BULK: 'bulk',
  SINGLE: 'single'
};

export const selectIdPrefix = 'select-';

export const routeActions = {
  CREATE: 'create',
  ADVANCED: 'advanced',
  MANAGE: 'manage',
  EDIT: 'edit'
};

export const searchStatuses = {
  PRESEARCH: 'PRESEARCH',
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR'
};

// Mutually-exclusive drawing states.
export const drawingStates = {
  NONE: 'none',
  SPLIT_ZONE_SELECTION: 'split_zone_selection',
  MERGE_ZONE_SELECTION: 'merge_zone_selection',
  DRAWING_PIVOT: 'drawing_pivot',
  DRAWING_SQUARE: 'drawing_square',
  DRAWING_POLYGON: 'drawing_polygon'
};

export const zoneSelectionModes = {
  DISABLED: 'disabled', // Zone selection is disabled.
  MULTI: 'multi', // Can select multiple zones at a time.
  SINGLE: 'single' // Can select one zone at time.
};

export const sort = {
  ASC: 'asc',
  DESC: 'desc'
};

export const MAX_ALLOWED_SOIL_TYPES = 3;

export const scriptConfigViews = {
  INPUTS: 'inputs',
  SUMMARY: 'summary'
};

export const APPLICATION_FORMAT = {
  sprayed:'sprayed',
  spread: 'spread'
};

export const NITROGEN_APPLICATION_RATE_TYPES = {
  nitrogen:'nitrogen',
  fertilizer: 'fertilizer'
};

export const DATA_LEGITIMACY = {
  legitimate: 'LEGITIMATE',
  artificial: 'ARTIFICIAL'
};
